// extracted by mini-css-extract-plugin
export default {"tags":"tags_tags__fnv2p","tags__lista":"tags_tags__lista__GxQCN"};